import { Facebook } from "lucide-react";
import { ASSETS, BRAND } from "./shared";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#3B2760] bg-[#26153F] py-12 px-6 md:px-12">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
      <div className="flex items-center gap-3">
        <img
          src={ASSETS.logo}
          alt={`${BRAND} logo`}
          loading="lazy"
          className="w-16 h-16 rounded-xl object-cover"
        />
      </div>
      <p className="text-xs text-[#A08FB8]">© 2026 {BRAND}. Inclusive coffee &amp; retro gaming.</p>
      <div className="flex items-center gap-4">
        <a
          data-testid="facebook-page-link"
          href="https://facebook-page-6.emergent.host"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-xs mono-lbl uppercase font-bold text-[#A08FB8] hover:text-[#FF2E88] transition-colors"
        >
          <Facebook className="w-4 h-4" />
          Facebook
        </a>
        <span className="text-xs mono-lbl text-[#A08FB8] uppercase">Step-Free • Sensory Mindful</span>
        <a
          data-testid="admin-login-link"
          href="/admin/login"
          className="text-xs mono-lbl uppercase text-[#A08FB8] hover:text-[#FF2E88] transition-colors"
        >
          Owner Login
        </a>
      </div>
    </div>
  </footer>
);
